"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibilityManagerByPlatform = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const visibilityManager_1 = require("./visibilityManager");
const mobileConnector_1 = require("../mobileConnector");
const VisibilityManagerByPlatform = ({ children, hideOn }) => {
    const currentPlatform = (0, mobileConnector_1.getCurrentPlatform)();
    return ((0, jsx_runtime_1.jsx)(visibilityManager_1.VisibilityManager, { hideOn: hideOn, currentValue: currentPlatform, children: children }));
};
exports.VisibilityManagerByPlatform = VisibilityManagerByPlatform;
//# sourceMappingURL=visibilityManagerByPlatfom.js.map